import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { Container as ContainerUI } from "@jti/core-components/components/Container";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

export const Container: FC<PropsWithChildren> = ({ children }) => {
  if (isEditing() && getBuilderChildrenCount(children) === 0) {
    return <Placeholder>Drag and drop component here</Placeholder>;
  }
  return <ContainerUI>{children}</ContainerUI>;
};
